module.exports = __webpack_public_path__ + "static/img/logo116.f72a462.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo116.png
// module id = zAFk
// module chunks = 1